import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const GeneralInfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(2),
}));

export const LocationTimezoneRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  alignItems: 'flex-start',
}));

export const LocationContainer = styled(Box)(() => ({
  flex: 1,
}));

export const TimezoneContainer = styled(Box)(() => ({
  flex: 0,
  minWidth: 280,
}));
